<template>
  <v-container pa-0 fluid>
    <v-layout row py-0>
      <v-flex xs12 md10 offset-md1>
        <v-container pa-0 fluid>
          <v-progress-linear
            :active="loading"
            height="3"
            class="my-0"
            :indeterminate="true"
          />
          <v-layout row py-0>
            <v-spacer />
            <v-menu
              v-model="filterMenu"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x
            >
              <template #activator="{ on }">
                <v-btn flat icon v-on="on">
                  <v-icon>tune</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-layout wrap row pa-3>
                  <v-flex xs12 px-2>
                    <v-select
                      v-model="phaseFilter"
                      :items="phases.map((item) => item.name)"
                      clearable
                      :label="
                        $t('action.actions.select', {
                          field: $tc('models.phase'),
                        })
                      "
                    />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-menu>
            <v-btn
              icon
              :loading="loading"
              @click="fetchRankingByGroup(tournamentId)"
            >
              <v-icon class="text--secondary"> refresh </v-icon>
            </v-btn>
          </v-layout>
          <v-layout
            v-for="(phase, index1) in phases.filter(
              (item) => !phaseFilter || item.name == phaseFilter
            )"
            :key="phase._id"
            row
            wrap
            py-0
            mb-4
          >
            <v-flex xs12 px-2 py-0>
              <v-card>
                <v-card-text class="px-0 py-1 primary white--text">
                  <v-flex text-xs-center>
                    <h2 class="headline">
                      {{ phase.name }}
                    </h2>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex
              v-for="group in phase.groups"
              :key="group._id"
              px-2
              py-3
              xs12
            >
              <v-card flat>
                <v-toolbar flat dense color="secondary" dark>
                  <v-toolbar-title>{{ group.name }}</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="body-1 pa-0">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-data-table
                        :headers="headers"
                        :items="group.ranking"
                        class="elevation-1"
                        item-key="_id"
                        :loading="loading"
                      >
                        <template slot="items" slot-scope="props">
                          <td class="text-xs-center">
                            {{ props.item.position }}
                          </td>
                          <td>
                            <v-chip small color="transparent">
                              <v-avatar size="32">
                                <img :src="props.item.logo" alt />
                              </v-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title class="body-1">
                                  {{ props.item.name }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title
                                  class="caption grey--text text--lighten-1 text-truncate"
                                >
                                  {{ props.item.categories.join(' - ') }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-chip>
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.playMatches }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.winMatches }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.tiedMatches }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.loseMatches }}
                          </td>
                          <!-- <td class="text-xs-center">{{props.item.goalsFavor}}</td>
                          <td class="text-xs-center">{{props.item.goalsAgainst}}</td>-->
                          <td class="text-xs-center">
                            {{ props.item.goalDifference }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.points }}
                          </td>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-divider
              v-if="index1 + 1 < phases.length"
              :key="`divider-phases-${index1}`"
              class="mt-3"
            />
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'TabGroupRanking',
  props: {
    tournament: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filterMenu: false,
      phaseFilter: '',
    }
  },
  computed: {
    ...mapState({
      tournamentId: (state) => state.tournaments.idSelected,
      loading: (state) => state.tournaments.loading,
      rankingByGroup: (state) => state.tournaments.rankingByGroup,
    }),

    phases() {
      if (!this.rankingByGroup || !this.rankingByGroup.phases) return []
      return this.rankingByGroup.phases
    },
    headers() {
      return [
        {
          text: this.$t('titles.tournaments.position').toUpperCase(),
          value: 'position',

          align: 'center',
        },
        {
          text: this.$tc('models.team').toUpperCase(),
          value: 'name',
        },

        {
          text: 'J',
          value: 'playMatches',
          align: 'center',
        },
        {
          text: 'G',
          value: 'winMatches',
          align: 'center',
        },
        {
          text: 'E',
          value: 'tiedMatches',
          align: 'center',
        },
        {
          text: 'P',
          value: 'loseMatches',
          align: 'center',
        },
        // {
        //   text: 'GF',
        //   value: 'goalsFavor',
        //   align: 'center'
        // },
        // {
        //   text: 'GC',
        //   value: 'goalsAgainst',
        //   align: 'center'
        // },
        {
          text: 'G+/-',
          value: 'goalDifference',
          align: 'center',
        },
        {
          text: 'Pts',
          value: 'points',
          align: 'center',
        },
      ]
    },
  },
  methods: {
    ...mapActions({
      fetchRankingByGroup: 'tournaments/fetchRankingByGroup',
    }),
  },
}
</script>
